import { render, staticRenderFns } from "./grossRule.vue?vue&type=template&id=01179361&scoped=true"
import script from "./grossRule.vue?vue&type=script&lang=js"
export * from "./grossRule.vue?vue&type=script&lang=js"
import style0 from "./grossRule.vue?vue&type=style&index=0&id=01179361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01179361",
  null
  
)

export default component.exports